import React, { useState } from 'react'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import Modal from 'components/Modal'
import TextInput from 'components/TextInput'

import Api from 'services/api'
import Apptentive from 'helpers/apptentive'
import GA4 from 'helpers/ga4'
import styled from 'styled-components'
import blobToFileDownload from 'helpers/blobToFileDownload'

import { ButtonContainer } from 'styles/shared'

type Props = {
  isOpen: boolean
  onClose: () => void
  deviceId: string
}

const RunReportModal = ({ isOpen, onClose, deviceId }: Props) => {
  const [filename, setFilename] = useState(`${deviceId}_warranty`)
  const [isSaving, setIsSaving] = useState(false)

  const onDownloadReportClick = () => {
    setIsSaving(true)

    Api.SystemComponents.report(deviceId, { filename }).then((res) => {
      blobToFileDownload(res, `${filename}.pdf`)

      Apptentive.sendEvent('download_warranty_report')
      GA4.sendEvent({
        category: 'Customer Detail Page',
        action: 'System Component Warranty PDF Report',
        label: 'Warranty Report'
      })

      setIsSaving(false)
      onClose()
    }).catch(() => {
      setIsSaving(false)
      onClose()
    })
  }

  return (
    <Modal
      title="Run Warranty Report"
      closeCallback={onClose}
      isDisplayed={isOpen}
    >
      <TextInput
        label="File Name"
        value={filename}
        onChange={(event) => setFilename(event.target.value)}
      />

      <ButtonContainer noBorder>
        <Button decoration="secondary" styles={{ button: { marginRight: 15 } }} text="Cancel" onPress={onClose} />
        <S.DownloadLink aria-label="system report download link">
          <Button decoration="positive" enabled={!isSaving} text="PDF Report" onPress={onDownloadReportClick} />
        </S.DownloadLink>
      </ButtonContainer>
    </Modal>
  )
}

const S = {
  DownloadLink: styled.a`
      margin: 5px 15px;
      display: inline-block;
  `
}

export default RunReportModal
